import { Pipe, PipeTransform } from '@angular/core';
import { MediaCategory } from 'src/app/models/media/media-category.model';

@Pipe({
  name: 'getCategoryNamePipe',
  pure: false,
})
export class GetCategoryNamePipe implements PipeTransform {
  transform(mediaCategoryId: number, mediaCategories: MediaCategory[]): any {
    // const excludedGroups: string[] = [];
    const category = mediaCategories.find(
      (category) => category.id === mediaCategoryId
    );
    return category?.name || '';
  }
}
